import { AccountStatusEnum } from '@/enums'

export const AccountStatusData = {
  [AccountStatusEnum.ACTIVE]: {
    label: `accountStatusOptions.${AccountStatusEnum.ACTIVE}`,
    color: 'green',
  },
  [AccountStatusEnum.INACTIVE]: {
    label: `accountStatusOptions.${AccountStatusEnum.INACTIVE}`,
    color: 'gray',
  },
  [AccountStatusEnum.BLOCKED]: {
    label: `accountStatusOptions.${AccountStatusEnum.BLOCKED}`,
    color: 'red',
  },
}
